import React from "react";
import SectionHeader from "../components/section/SectionHeader";
import NewLocationForm from "../components/locations/NewLocationForm";
import { CREATE_LOCATION_TRANSLATIONS } from "../translations/util";

const NewLocation = () => {
  return (
    <>
      <SectionHeader
        pageTitle={CREATE_LOCATION_TRANSLATIONS.header}
        pageDescription={CREATE_LOCATION_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={<div className="dropdown-details" />}
      />

      <div className="main-content">
        <NewLocationForm />
      </div>
    </>
  );
};

export default NewLocation;
